// import useNavigation from "./hooks/useNavigation";
// import Button from "../../components/Button";
// import { P2 } from "../../components/Paragraph";
import { Link } from "react-router-dom";
import ClassLink from "../menuLinks/ClassLink";
import TasksLink from "../menuLinks/TasksLink";
import LessonsLink from "../menuLinks/LessonsLink";
import MasteryLink from "../menuLinks/MasteryLink";
import HistoryWidget from "../widgets/historyWidget/HistoryWidget";
import StatisticsWidget from "../widgets/statisticsWidget/StatisticsWidget";
import classNames from "classnames";
import styles from "./sideNav.module.css";

const SideNav = ({ expanded }) => {
  // const { sections } = useNavigation();
  return (
    <div className={styles.sideNav}>
      <Link to="/" style={{ display: "flex" }}>
        {expanded ? (
          <img
            key="logotype"
            src={"/logotype.png"}
            alt={"logo"}
            className={styles.logo}
          />
        ) : (
          <img
            key="logo"
            src={"/logo.png"}
            alt={"logo"}
            className={classNames(styles.logo, {
              [styles.collapsed]: !expanded,
            })}
          />
        )}
      </Link>
      <ClassLink />
      <TasksLink />
      <LessonsLink />
      <MasteryLink />
      <div style={{ display: "flex", flexGrow: "1" }} />
      <HistoryWidget />
      <StatisticsWidget />
      {/*
      <nav>
        {sections.map((section, idx) => (
          <div key={`${section.id}${section.title ? section.title : ""}`}>
            <hr />
            {section?.title ? (
              <div style={{ marginBottom: "var(--gap-base)" }}>
                <P2>{section?.title}</P2>
              </div>
            ) : null}
            {section?.links?.map((link) => (
              <Button
                sideNav
                pressed={link.selected}
                key={link.to}
                icon={link.icon}
                to={link.to}
              >
                {expanded ? link.caption : null}
              </Button>
            ))}
          </div>
        ))}
      </nav>
      */}
    </div>
  );
};

export default SideNav;
